import {  Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, Observable, Subscription } from 'rxjs';

import { saveAs } from '@progress/kendo-file-saver';

import {
  CompositeFilterDescriptor,
  process, 
  State, 
  DataResult} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  FilterService} from "@progress/kendo-angular-grid";


  import {
    ScreenListsService,
    PafListsService,
    SharedDataService,
    LoggedUserService,
    DocumentsService,
    Family,
    ContactStoredData,
    SimpleReponseResult,
    DocumentsListParameters,
    LegalForm,
    PafLabelDirective,
    DocumentStatut,
    DocTyp,
    PS_Lst_Documentaire_Result,
    Country,
    PafDocument,
    ChangeStatutParams
  } from 'ngx-paf-common';
  
  import moment from 'moment';
  import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'lst-documentaires',
  templateUrl: './lst-documentaires.component.html',
  styleUrls: ['./lst-documentaires.component.scss'],
  encapsulation:ViewEncapsulation.None,  //Permet d'utiliser le style redefini pour la grille dans style.scss et non le style global Telerik
})
export class LstDocumentairesComponent implements OnInit, OnDestroy  {

  private _Subs:Subscription[]=[];

  constructor(
    private screenListsSvc: ScreenListsService,
    private pafLists: PafListsService,
    private docsSvc: DocumentsService,
    private route: ActivatedRoute,
    public sharedDataSvc: SharedDataService,
    private loggedUserSvc: LoggedUserService) {
      this.allData = this.allData.bind(this);
    }
  
    public allData(): ExcelExportData {
      const result: ExcelExportData = {
        data: process(this.documents, {
          sort: [{ field: "SupplierName", dir: "asc" }],
        }).data
      };
  
      return result;
    }
  

  private _autoSearchOnLoad:boolean = false; // mettre à true si recherche auto au démarrage
  //---------------------------------------
  
  ngOnInit(): void {
    if (!this.sharedDataSvc.allListsLoaded){
     this._Subs.push(  this.sharedDataSvc.allListsLoadedChange.subscribe(res=> this.afterLabelLoaded(this._autoSearchOnLoad)));
    } else {
      this.afterLabelLoaded(this._autoSearchOnLoad);
    }
  }
ngOnDestroy(): void {
    this._Subs.forEach(sub=>sub.unsubscribe());
  }
 
LstFamiliesFilterChange(value:any):void{  
    this.familySearchMask = value;
}


  //@ViewChild('excelexport') excelExportComponent:ExcelExportComponent;
  public filters: DocumentsListParameters = new DocumentsListParameters();
  public documents:PS_Lst_Documentaire_Result[]=[];
  public allDocStatuts: DocumentStatut[]=[];
  public lstFamilies:Family[]=[];
  public lstDocTyps:DocTyp[]=[];
  public lstPafDocuments:PafDocument[]=[];
  public lstLegalForms:LegalForm[]=[];
  public lstEtatDocumentaire:string[]=['Complet','Incomplet'];
  
  public get lstDocStatuts(): DocumentStatut[]{
    if (!this.filters.InclureArchive){
      return this.allDocStatuts;
    } else {
      return this.allDocStatuts.filter(st=>st.Cod!='ARCHIVE');
    }
  }
  selectedRow:PS_Lst_Documentaire_Result = null;
  selectedDocStatuts:DocumentStatut[]=[];
  selectedFamilies:Family[]=[];
  selectedDocTyps:DocTyp[]=[];
  selectedPafDocuments:PafDocument[]=[];

  public get selectedLegalForm():LegalForm | undefined {
    return this.sharedDataSvc.legalForms.find(item=>item.Id==this.filters.LegalFormId);
  }

  country?: Country;

  get selectedCountry():Country | undefined{
    return this.country;
  }


  get filteredPafDocuments():PafDocument[]{
    if (this.selectedDocTyps.length==0){
      return this.lstPafDocuments;
    } else {
      return this.lstPafDocuments.filter(d=> this.selectedDocTyps.map(dt=>dt.Id).indexOf(d.DocTypId)>=0);
    }
  }

  get countryLegalForms():LegalForm[]{
    return this.lstLegalForms.filter(lf=>lf.CountryId==this.country?.Id);
  }

  
  public reinit() {
    this.documents = [];
    this.filters = new DocumentsListParameters();
    this.selectedDocStatuts=this.lstDocStatuts.filter(st=>st.Cod=='A_VALIDER');
    this.selectedFamilies=[];
    this.selectedRow = null;
    this.selectedPafDocuments = [];
    this.selectedDocTyps = this.lstDocTyps.filter(d=>d.Cod=='ACHATS');
    this.country = this.sharedDataSvc.countries.find(c=>c.CountryCod2=='FR');
    this.state = {
      skip: 0,
      take: 100
    };
    this.gridData = <DataResult>process(this.documents, this.state);
    this.storeFilters().subscribe();
  }
  
  userDatas:ContactStoredData[]=[];
  visibleFilters: boolean = true;
  gridData:  DataResult;
  state: State = {
    skip: 0,
    take: 100
  };
  public gridPageableSettings:any = {
      pageSizes: [10,20,50,100],
      position:'top'
  }

  toggleDisplayFilters():void{
    this.visibleFilters = !this.visibleFilters;
  }

  public familyClass(dataItem: Family, indented:boolean=false):any{
    let ngClass: any =this.pafLists.familyClass(dataItem.Id,this.lstFamilies);
    if (indented){
      let familyLevel:number = this.pafLists.familyLevel(dataItem.Id,this.lstFamilies)+1;
      ngClass['ml-'+familyLevel.toString()]=true;
    }
    return ngClass;
  }

  public familyLabel(dataItem: Family): string {
    return this.pafLists.familyLabel(dataItem.Id,this.lstFamilies,true);
  }
  public familyIcon(dataItem: Family): any {
    return this.pafLists.familyIcon(dataItem.Id,this.lstFamilies);
  }
  public familyIconClass(dataItem: Family): any {
    return this.pafLists.familyIconClass(dataItem.Id,this.lstFamilies);
  }

  get excelExportFileName(): string {
    let curDate: string =moment().format('DD-MM-YYYY HH-mm');
    return 'Liste fournisseurs ' + curDate + '.xlsx';
  }

  afterLabelLoaded(autoSearch:boolean = false):void{
     let LegalFormId:number = this.filters.LegalFormId;
    this.filters.LegalFormId = LegalFormId;
    this.country = this.sharedDataSvc.countries.find(c=>c.Id== this.selectedLegalForm?.CountryId);
    if (!this.country) this.country = this.sharedDataSvc.countries.find(c=>c.CountryCod2=='FR');
    let autoSearchFunction:()=>any=null;
    if (autoSearch){
      autoSearchFunction = ():void=>{this.search()};
    }
    this.loadFixedLists(():void=>{
      if (this.sharedDataSvc.loggedIntUser!= null){
        this.reloadVariableLists(autoSearchFunction);
      } else {
        this.sharedDataSvc.loggedIntUserChange.subscribe(res=>{
          this.reloadVariableLists(autoSearchFunction);
        });        
      }     
    });   
  }

  public search(alreadyPrompted: boolean = false, callback:()=>any = null): void {
    this.selectedRow = null;
    this.storeFilters()
    .subscribe(res=>{
      const cptFilters= alreadyPrompted? 20 : this.filtersCount;
      if (cptFilters<2){
        this.sharedDataSvc.confirm('La recherche peut être longue s\'il n\'y a pas à minima 2 filtres renseignés. Poursuivre malgré tout?',
        ():void=>this.search(true,callback),
        null);
        return;
      }
      this.sharedDataSvc.WindowLock();
      this.screenListsSvc.DocumentsList (this.filters)
        .subscribe((res: PS_Lst_Documentaire_Result[]) => {
          res.forEach(item=>{
            (<any>item).dossierComplet = (item.TopComplet==1);
            (<any>item).EtatDossier = (item.TopComplet==1 ? 'Complet' : 'Incomplet');
          });
          this.documents = res;
          if ((this.state.skip || 0) > res.length) {
            this.state = {
              skip: 0,
              take: 10
            };
          }
          res.sortObject('DocId');
          this.gridData = process(this.documents, this.state);
        },
        (err:any):void=>{this.sharedDataSvc.alert(err.Message ||err)},
        ():void=> {
          if (callback) callback();
          this.sharedDataSvc.WindowUnlock();
        });
    });
  }

  get filtersCount():number {
    let ret: number = 0;
    if (this.filters.SupplierName) ret++;
    if (this.filters.DocStatutIds.length>0) ret++;
    if (this.filters.FamiliesIds.length>0) ret++;
    if (this.filters.DoctypIds.length>0) ret++;
    if (this.filters.PafDocumentIds.length>0) ret++;
    if (this.filters.CountryId) ret++;
    if (this.filters.LegalFormId) ret++;
    if (this.filters.MntFacMin) ret++;
    if (this.filters.MntFacMax) ret++;
    if (this.filters.DateExpiDeb) ret++;
    if (this.filters.DateExpiFin) ret++;
    if (this.filters.EtatDossier) ret++;    
    return ret;
  }

  loadFixedLists(callBack:()=>any = null):void{
    this.lstFamilies=[];
    this.lstLegalForms = [];
    this.allDocStatuts = [];
    this.lstDocTyps = [];
    this.lstPafDocuments = [];
    forkJoin([
      this.pafLists.getFamilies(),
      this.pafLists.getLegalForms(),
      this.docsSvc.getDocumentStatuts(),
      this.docsSvc.getDocTyps(),
      this.docsSvc.getPafDocuments()
      ]).subscribe( results => {
        this.lstFamilies=results[0];
        this.lstLegalForms=results[1];
        this.allDocStatuts = results[2].filter(st=> st.Cod.indexOf('RELANCE')<0 );
        this.lstDocTyps = results[3].filter(dt=>dt.Cod!='MODELES');
        this.lstPafDocuments = results[4];
        this.lstFamilies.forEach((f:Family)=>{
            (<any>f).Display= this.familyLabel(f);
          });
        this.lstFamilies.sortObject('Display');
        this.lstDocStatuts.forEach((s:DocumentStatut)=>(<any>s).Display= this.sharedDataSvc.getLoadedLabel(s.LblCod));
        this.lstDocStatuts.sortObject('LblCod');
        this.lstDocTyps.forEach((s: DocTyp) => (<any>s).Display= this.sharedDataSvc.getLoadedLabel(s.LblCod));
        this.lstDocTyps.sortObject('LblCod');
        this.lstPafDocuments.forEach((s: PafDocument) => (<any>s).Display= this.sharedDataSvc.getLoadedLabel(s.LblCod));
        this.lstPafDocuments.sortObject('LblCod');
        if (callBack) callBack();
    });
  }

  reloadVariableLists(callBack:()=>any = null):void{
    this.userDatas = [];
    forkJoin([
      this.loggedUserSvc.LoggedUserStoredDatas(),
    ]).subscribe( results => {
       this.userDatas = results[0];
        this.loadFilters();
        if (callBack) callBack();
      }
    );
  }


  loadFilters():void{
    if (this.userDatas.some(ud=>ud.Key=='DOCUMENTS-LIST-FILTERS')){
      this.filters = JSON.parse(this.userDatas.find(ud=>ud.Key=='DOCUMENTS-LIST-FILTERS').Datas);
      if (this.filters.DateDocDeb) this.filters.DateDocDeb=moment(this.filters.DateDocDeb).toDate();
      if (this.filters.DateDocFin) this.filters.DateDocFin=moment(this.filters.DateDocFin).toDate();
       if (this.filters.DateExpiDeb) this.filters.DateExpiDeb=moment(this.filters.DateExpiDeb).toDate();
      if (this.filters.DateExpiFin) this.filters.DateExpiFin=moment(this.filters.DateExpiFin).toDate();

      this.selectedDocStatuts = this.lstDocStatuts.filter(s=> this.filters.DocStatutIds.indexOf(s.Id)>=0);
      this.selectedFamilies = this.lstFamilies.filter(s=> this.filters.FamiliesIds.indexOf(s.Id)>=0);
      this.selectedDocTyps = this.lstDocTyps.filter(s=> this.filters.DoctypIds.indexOf(s.Id)>=0);
      this.selectedPafDocuments = this.lstPafDocuments.filter(s=> this.filters.PafDocumentIds.indexOf(s.Id)>=0);
    } else {
      this.reinit();
    }
    if (this.userDatas.some(ud=>ud.Key=='DOCUMENTS-LIST-GRIDSTATE')){
      this.state = JSON.parse(this.userDatas.find(ud=>ud.Key=='DOCUMENTS-LIST-GRIDSTATE').Datas);
    }
    this.filters.EtatDossier = this.filters.EtatDossier || 'Tous';
  }

  storeFilters():Observable<[SimpleReponseResult,SimpleReponseResult]>{
    this.filters.DocStatutIds = this.lstDocStatuts.filter(s=> this.selectedDocStatuts.some(s2=>s2.Id==s.Id)).map(s=>s.Id); 
    this.filters.FamiliesIds = this.selectedFamilies.map(f=>f.Id);
    this.filters.DoctypIds = this.selectedDocTyps.map(f=>f.Id);
    this.filters.PafDocumentIds = this.selectedPafDocuments.map(f=>f.Id);
    this.filters.LegalFormId = this.selectedLegalForm?.Id ||0;
    this.filters.CountryId = this.selectedCountry?.Id ||0;

    return forkJoin([
      this.loggedUserSvc.StoreDatas('DOCUMENTS-LIST-FILTERS',this.filters),
      this.loggedUserSvc.StoreDatas('DOCUMENTS-LIST-GRIDSTATE',this.state)
    ]);    
  }

//---------------------------------------
//Liste des familles d'achats
  @ViewChild('lstFamiliesCbo', {read: ElementRef}) lstFamiliesCbo: MultiSelectComponent; 
  familySearchMask : string='';
  get lstFamiliesFiltered():Family[]
  {
      if (!this.familySearchMask){
        return this.lstFamilies;
      } else {
        return this.lstFamilies.filter(f=> {
          let display: string = (<any>f).Display;
          return display.toLowerCase().removeAccents().indexOf(this.familySearchMask.toLowerCase().removeAccents())>=0;
        });
      }
  }

  
  public highlightSearch(display: string, search:string) : string {
    if (!display||!search) return display;
    let startIndex: number=display.toLowerCase().removeAccents().indexOf(search.toLowerCase().removeAccents());
    if (startIndex<0) return display;
    
      let endIndex = startIndex + search.length;
      return [
        display.slice(0, startIndex),
        '<mark>',
        display.slice(startIndex, endIndex),
        '</mark>',
        display.slice(endIndex)
      ].join('');
  }


  
  //-------------------------------------
  // Filtres sur Grid

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.state.filter = filter;
       let filterDatas:PS_Lst_Documentaire_Result[]=this.documents;
       this.gridData = process(filterDatas , this.state);
     }
     
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.documents, this.state);
  }

  public gridFiltersChange(values: any[], filterService: FilterService,column:any): void {
    filterService.filter({
      filters: values.map((value) => ({
        field: column.field,
        operator: "eq",
        value,
      })),
      logic: "or",
    });
  }


  checkNgClass(fieldValue:number):any{
      return {
        'far': true,
        'fa-check-square':(fieldValue==1),
        'fa-square':(fieldValue!=1),
    }
  }

  
  btnDownloadFileClick(doc: PS_Lst_Documentaire_Result): void {
    this.docsSvc.downloadFile(doc.SupplierId, doc.DocId)
      .subscribe(blob => {
        saveAs(blob, doc.Filename);
      });
  }

  docCssTxtStatut(doc:PS_Lst_Documentaire_Result):string{
    if (!doc?.cssStatut) return '';
    return 'text-'+doc.cssStatut;
  }

  docCssBadgeStatut(doc:PS_Lst_Documentaire_Result):string{
    if (!doc?.cssStatut) return '';
    return 'badge badge-'+doc.cssStatut;
  }
  getSupplierLink(doc:PS_Lst_Documentaire_Result):string {
    if (!doc) return '';
    return '/supplier-details/'+doc.SupplierId+'/list-documentaires';
  }
  
  
  validateDoc(doc:PS_Lst_Documentaire_Result):void{
    if (!doc || !doc.SupplierId) return;
    let params:ChangeStatutParams =new ChangeStatutParams();
    params.SupplierId = doc.SupplierId;
    params.documentId = doc.DocId;
    params.CurrentStatutId = doc.StatutId;
    params.NewStatutId = this.lstDocStatuts.find(ds=>ds.Cod=='CONFORME').Id;
    this.docsSvc.ChangeStatut(doc.SupplierId,params)
      .subscribe((res:SimpleReponseResult)=>{
        if (!res.Ok){
          this.sharedDataSvc.alert(res.Message);
        } else {
          this.search();
        }
      });
  }

  unvalidateDoc(doc:PS_Lst_Documentaire_Result):void{
    if (!doc || !doc.SupplierId) return;
    let params:ChangeStatutParams =new ChangeStatutParams();
    params.SupplierId = doc.SupplierId;
    params.documentId = doc.DocId;
    params.CurrentStatutId = doc.StatutId;
    params.NewStatutId = this.lstDocStatuts.find(ds=>ds.Cod=='NON_CONFORME').Id;
    this.sharedDataSvc.pafPrompt('Saisir_un_motif_de_rejet',
      (motifRejet: string):void=>{
        params.Comments = motifRejet;
        this.docsSvc.ChangeStatut(doc.SupplierId,params)
          .subscribe((res:SimpleReponseResult)=>{
            if (!res.Ok){
              this.sharedDataSvc.alert(res.Message);
            } else {
              this.search();
            }
          });
      });
  }

  get ProfilAuthorise():boolean{
    if (!this.sharedDataSvc?.profil) return false;
    return ['DEMANDEUR','ASSISTANT','FOURNISSEUR'].indexOf(this.sharedDataSvc?.profil?.Cod)<0;
  }

  get ValidationColumnVisible():boolean{
    if (!this.sharedDataSvc?.profil) return false;
    return ['CTRL_QUAL','ADMIN'].indexOf(this.sharedDataSvc?.profil?.Cod)>=0;
  }
}
